import { omitDeep } from "./omitDeep.js";
export function stripTypename(value) {
    return omitDeep(value, "__typename");
}
//# sourceMappingURL=stripTypename.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@apollo/client/utilities/common/stripTypename.js
// module id = 2103
// module chunks = 11